export const rewardsPaneHeaderText = "Uu2Fmb";
export const microsoftRewardsTitle = "UE7cgc";
export const loadingRewardsText = "d7$R6";
export default {rewardsPaneHeaderText,microsoftRewardsTitle,loadingRewardsText};